import {
  Badge,
  Text,
  Button,
  Box,
} from '@usealloy/component-library';
import styled, { css } from 'styled-components';
import { ContainerType } from '../../../../types';

/**
 * Max-width pixel value specified to fit within StyledOutputValue
 */
export const StyledOutputBadge = styled(Badge)<{ satisfiesLogic: boolean }>`
  && {
    background-color: ${({ satisfiesLogic }) => (satisfiesLogic ? 'var(--cl-yellow-100)' : 'var(--cl-gray-100)')};
    max-width: 180px;
    overflow: hidden;
    z-index: 1;
    margin-left: var(--cl-space-1);
  }
`;

export const StyledOutputText = styled(Text)`
  && {
    font-family: var(--cl-font-family-default);
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

/**
 * Specific pixel width for output values section
 * See Rule Explainability Figma design
 */
export const StyledOutputValueWrapper = styled.div<{ containerType: ContainerType }>`
    display: flex;
    justify-content: flex-start;
    border-left: 1px solid var(--cl-gray-500);
    padding-left: var(--cl-space-5);
    width: 15%;

  ${({ containerType }) => (containerType === ContainerType.ISLAND
      && css`
        min-width: auto;
        width: auto;
        padding-left: var(--cl-space-2);
        padding-right: var(--cl-space-2);
      `
  )}
`;

export const StyledEvidencesButton = styled(Button)`
  && {
    height: var(--cl-space-5);
    width: var(--cl-space-5);
    min-width: var(--cl-space-5);
  }
`;

export const StyledOutputBadgeContainer = styled(Box)`
  width: 70%;
  align-items: center;
  justify-content: flex-start;
`;

export const StyledGreenDot = styled.div<{ isVisible: boolean }>`
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  width: var(--cl-space-2);
  height: var(--cl-space-2);
  background-color: var(--cl-green-300);
  border-radius: 100%;
  flex: 0 0 var(--cl-space-2);
  z-index: 1;
`;
